<template>
  <div>
    <div class="feedback">
      <transition name="fade" @enter="enterSuccessFeedback">
        <FeedbackSuccess
          v-if="showableSuccessFeedback"
          :message="successMessage"
        />
      </transition>
      <transition name="fade" @enter="enterErrorFeedback">
        <FeedbackError v-if="showableErrorFeedback" :message="errorMessage" />
      </transition>
    </div>
    <div v-if="isProfileLoading" class="profile-show-section__profile-content">
      <SmallLoading />
    </div>
    <div v-else class="profile-show-section__profile-content">
      <div v-if="showableEditLink" class="profile-show-section__edit-area">
        <div class="profile-show-section__edit-link">
          <a :href="editMypageProfilePath"> 編集 </a>
        </div>
      </div>
      <div class="profile-show-section__info-area">
        <div class="profile-show-section__icon">
          <AccountIconWh104
            class="profile-edit-form__account-icon"
            :image-url="profileIconImagePath"
          />
        </div>
        <div class="profile-show-section__nickname-birthday-area">
          <div
            v-if="!isInfoPublic"
            class="profile-show-section__private caption"
          >
            非公開
          </div>
          <div class="profile-show-section__nickname subhead-bold">
            <div class="profile-show-section__user-nickname">
              {{ nickname }}
            </div>
          </div>
          <div
            v-if="birthdayDisplayable"
            class="profile-show-section__birthday hint"
          >
            誕生日 {{ birthdayText }}
          </div>
        </div>
      </div>
      <div class="profile-show-section__description body">
        {{ descriptionContent }}
      </div>
      <PublishProfileContents
        v-if="showableEditLink"
        :is-info-public="isInfoPublic"
        @change-info-public="changeInfoPublic"
      />
      <FollowContents
        v-if="!isCurrentUser"
        :nickname="nickname"
        :user-id="userId"
        :is-app="isApp"
        :mypage-follows-path="mypageFollowsPath"
        :screen-name="screenName"
      />
    </div>
  </div>
</template>

<script>
import PublishProfileContents from '../../../organism/mypages/profiles/PublishProfileContents.vue'
import FollowContents from '../../../organism/mypages/profiles/FollowContents.vue'
import AccountIconWh104 from '../../../atoms/account_icons/AccountIconWh104.vue'
import FeedbackSuccess from '../../../atoms/feedbacks/feedback-success.vue'
import FeedbackError from '../../../atoms/feedbacks/feedback-error.vue'
import SmallLoading from '../../../atoms/loadings/SmallLoading.vue'

import axios from 'axios'

export default {
  components: {
    PublishProfileContents,
    FollowContents,
    AccountIconWh104,
    FeedbackSuccess,
    FeedbackError,
    SmallLoading
  },
  props: {
    showableEditLink: {
      type: Boolean,
      required: true
    },
    editMypageProfilePath: {
      type: String,
      required: true
    },
    profileIconImagePath: {
      type: String,
      required: true
    },
    nickname: {
      type: String,
      required: true
    },
    birthdayDisplayable: {
      type: Boolean,
      required: true
    },
    birthdayText: {
      type: String,
      required: true
    },
    descriptionContent: {
      type: String,
      required: true
    },
    isCurrentUser: {
      type: Boolean,
      required: true
    },
    userId: {
      type: Number,
      required: true
    },
    isApp: {
      type: Boolean,
      required: true
    },
    mypageFollowsPath: {
      type: String,
      required: true
    },
    screenName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showableSuccessFeedback: false,
      showableErrorFeedback: false,
      successMessage: '',
      errorMessage: '',
      showModal: false,
      isProfileLoading: false,
      isInfoPublic: false,
      following: false,
      isFollowingStatusLoading: false
    }
  },
  mounted() {
    this.getProfile()
    this.getFollowStatus()
  },
  methods: {
    enterSuccessFeedback() {
      setTimeout(() => {
        this.showableSuccessFeedback = false
      }, 3000)
    },
    enterErrorFeedback() {
      setTimeout(() => {
        this.showableErrorFeedback = false
      }, 3000)
    },
    showFeedback(message) {
      this.showableSuccessFeedback = true
      this.successMessage = message
    },
    async getProfile() {
      this.isProfileLoading = true
      try {
        const res = await axios.get(`/api/v1/profiles/${this.screenName}`)
        this.isInfoPublic = res.data.data.attributes.info_public
        this.isProfileLoading = false
      } catch (error) {
        this.isProfileLoading = false
        this.showableErrorFeedback = true
        // error.response.data.message が null の場合に備えて初期値をセットする
        this.errorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'システムエラーが発生しました。しばらく経ってから再度アクセスしてください'
      }
    },
    closeModal() {
      this.showModal = false
    },
    openModal() {
      this.showModal = true
    },
    async getFollowStatus() {
      this.isFollowingStatusLoading = true
      try {
        const res = await axios.get(
          `/api/v1/pickup/follows/follow_status?screen_name=${this.screenName}`
        )
        if (res.data.status === 200) {
          this.following = res.data.following_status
          this.isFollowingStatusLoading = false
        }
      } catch (error) {
        this.showableErrorFeedback = true
        this.errorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'システムエラーが発生しました。しばらく経ってから再度アクセスしてください'
      }
    },
    changeInfoPublic(infoPublic) {
      this.isInfoPublic = infoPublic
    }
  }
}
</script>
<style lang="scss" scoped>
.profile-show-section {
  &__profile-content {
    margin: auto;
    max-width: $small-contents-width;
  }

  &__edit-area {
    text-align: right;
  }

  &__info-area {
    display: flex;
    align-items: center;
    text-align: left;
  }

  &__edit-link {
    @extend %body;

    margin-left: auto;

    a {
      color: $link;
    }
  }

  &__icon {
    padding-right: 16px;
  }

  &__birthday {
    margin-top: 8px;
    padding-left: 20px;
    @include bg-settings(
      '../../../../../../images/icons/birthday.svg',
      $white,
      16px,
      20px
    );

    text-align: left;
  }

  &__nickname {
    display: flex;
    align-items: center;
  }

  &__description {
    margin: 24px auto;

    text-align: left;
    word-wrap: break-word;
    white-space: pre-wrap;
  }

  &__foot {
    margin: 0 auto;
    padding: 24px 0;
    background-color: $white;
  }

  &__private {
    padding-left: 16px;
    @include bg-settings(
      '../../../../../../images/icons/lock-outline.svg',
      $white,
      16px,
      16px
    );

    margin-bottom: 8px;
    font-weight: normal;
    color: $black;
    white-space: nowrap;
  }
}
</style>
